import { toast } from "react-toastify"
import axiosInstance from "../axios/axiosInstance"

export const handeleUpdateStatus = async (reqId: any, status: any) => {
    try {
        const resp: any = await axiosInstance.put(`/api/request/${reqId}`, { status: status })
        if (resp.status === 200) {
            // toast.success("Status updated successfully")
            // return true
        }

    } catch (error: any) {
        toast.error(error.response?.data?.body)
        // return false
    }
}